import React, { Suspense } from 'react';
import gql from 'graphql-tag';
import { ApolloProvider, useQuery } from '@apollo/client';
import { AppConfigService } from '@aperza/util';
import ReactDOM from 'react-dom';
import Header from './Header';
import UserSection from '../user/UserSection';
import NavBar from '../navbar/NavBar';
const QUERY = gql `
  query HeaderLoaderQuery($params: String!) {
    viewer {
      id
      aperzaId
      userId
      cartBadge {
        approvalFlag
        totalPurchaseNumber
      }
      searchModel(params: $params) {
        count
      }
      searchItem(params: $params) {
        count
      }
      searchCatalog(params: $params) {
        count
      }
      searchNews(params: $params) {
        count
      }
      ...UserSection_viewer
      ...NavBar_viewer
    }
  }
  ${UserSection.fragments.viewer}
  ${NavBar.fragments.viewer}
`;
const HeaderLoader = (props) => {
    const { loading, error, data, refetch } = useQuery(QUERY, {
        variables: {
            params: JSON.stringify(AppConfigService.getSearchParams() || {}),
        },
    });
    if (loading)
        return React.createElement("div", null, "LOADING");
    if (!loading || data) {
        const initEl = document.getElementById('aperza-header-init');
        if (initEl) {
            initEl.style.display = 'none';
        }
    }
    const headerProps = {
        ...AppConfigService.resolveHeaderConfigurations(),
        ...props,
    };
    const doRefetch = () => {
        if (refetch) {
            return refetch({
                params: JSON.stringify(AppConfigService.getSearchParams() || {}),
            });
        }
    };
    // return <div>HELLO</div>;
    return React.createElement(Header, { viewer: data.viewer, refetch: doRefetch, ...headerProps });
};
export default HeaderLoader;
const renderHeader = (apolloClient) => {
    const headerElement = document.getElementById('aperza-header');
    if (headerElement) {
        ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(HeaderLoader, null))), headerElement);
    }
};
export { HeaderLoader, renderHeader };
